module.exports = __webpack_public_path__ + "img/message7.1dab1a0a.png";